export const errorsMap = {
    100002: "Nie znaleziono użytkownika"
}
